import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["onClick", "onKeydown"]
const _hoisted_2 = ["onClick", "onKeydown"]
const _hoisted_3 = ["aria-pressed", "aria-controls", "onClick"]
const _hoisted_4 = ["id", "aria-hidden"]

import { 
		onMounted, 
		ref, 
		computed, 
		watch 
	} from 'vue';

	
export default /*#__PURE__*/_defineComponent({
  name: 'TabBlock',
  props: {
    uid: null,
    screenSize: null,
    useMobileNav: { type: Boolean },
    default: null,
    current: null,
    tabs: null,
    centerTabs: { type: Boolean },
    disableAnimation: { type: Boolean },
    scrollOnMobile: null,
    fixedHeaderEl: null
  },
  emits: ['change'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
		uid: string,
		screenSize?: number,
		useMobileNav?: boolean,
		default?: number,
		current?: number,
		tabs: number, 
		centerTabs?: boolean, 
		disableAnimation?: boolean,
		scrollOnMobile?: number,
		fixedHeaderEl?: string
	}

	

	

	const isTabPanelListScrollable = ref(false);
	const tabPanelTabs = ref(null);
	const tabPanelList = ref(null);
	const tabPanels: any = ref([]);
	const current = ref(typeof props.current == 'number' ? props.current : typeof props.default == 'number' ? props.default : 0);
	const scrolledTabPanel = ref(current.value);
	const minHeight = ref(0);

	const scrollOnMobile = computed(() => props.scrollOnMobile);
	const useMobileNav = computed(() => props.useMobileNav);
	const screenSize = computed(() => props.screenSize);
	const centerTabs = computed(() => props.centerTabs);
	const disableAnimation = computed(() => props.disableAnimation);
	const panelHolderStyle = computed((): string => enablePanelHolderStyle.value ? `height:${minHeight.value}px;` : '');
	const enablePanelHolderStyle = ref(true);
	const tabs = computed((): number => props.tabs);

	const handleTabClick = (i: number) => {
		setPanelHeight(i);
		current.value = i;
		emits('change', i);
		setTabScrollTopPosition();
	}
	const setPanelHeight = (i: number, instant?: boolean) => {
		if (i < 0 || i >= tabPanels.value.length) return;
		const div: HTMLElement = tabPanels.value[i];
		const newHeight = div.clientHeight;
		enablePanelHolderStyle.value = true;

		if (instant){
			setPanelNewHeightPre(newHeight);
			setPanelHeightPost();
		}
		else {
			setTimeout(() => setPanelNewHeightPre(newHeight), 250);
			setTimeout(setPanelHeightPost, 750);
		}
	}
	const setPanelNewHeightPre = (newHeight: number) => {
		minHeight.value = newHeight;
	};
	const setPanelHeightPost = () => {
		enablePanelHolderStyle.value = false;
	};
	const setNavVisibility = () => {
		// if (!useMobileNav.value) return;
		const listEl = (tabPanelList.value as unknown as HTMLUListElement);
		const listItems = listEl.children;
		let totalWidth = 0;
		for (let i = 0; i != listItems.length; ++i){
			totalWidth += listItems[i].clientWidth;
		}
		isTabPanelListScrollable.value = totalWidth > listEl.clientWidth;
	}
	const setNavScrollPosition = () => {
		const el = (tabPanelList.value as unknown as HTMLUListElement);
		if (!el || !isTabPanelListScrollable.value) return;// || !useMobileNav.value
		const elChildren = Array.from(el.children);
		const ch = (elChildren[scrolledTabPanel.value] as HTMLElement);
		const tabPanelLeft = el.offsetLeft;
		const chLeft = ch.offsetLeft;
		const chRelativeLeft = chLeft - tabPanelLeft;

		el.scrollTo({
			left: chRelativeLeft - 20, 
			behavior: 'smooth'
		});
	};
	const setTabScrollTopPosition = (): void => {
		if (scrollOnMobile.value && window.innerWidth <= scrollOnMobile.value){
			const el2 = (tabPanelTabs.value as unknown as HTMLElement);
			if (!el2) return;
			const li = document.getElementById('nvi-listing-header');
			const offset = li?.clientHeight || 0;
			const tabPanelTop = el2.getBoundingClientRect().top;
			const offset2El = props.fixedHeaderEl ? document.querySelector(props.fixedHeaderEl) : null;
			const isOffset2Sticky = offset2El ? window.getComputedStyle(offset2El).position == 'fixed' : false;
			const offset2 = isOffset2Sticky ? offset2El?.clientHeight || 0 : 0;

			setTimeout(() => {
				window.scrollTo({
					top: tabPanelTop + window.scrollY - offset - offset2 - 48, 
					behavior: 'smooth'
				});
			}, 250);
		}
	};
	const handleLeftClick = (): void => {
		if (scrolledTabPanel.value){
			scrolledTabPanel.value = scrolledTabPanel.value - 1;
			setNavScrollPosition();
		}
	};
	const handleRightClick = (): void => {
		if (scrolledTabPanel.value < tabs.value - 1){
			scrolledTabPanel.value = scrolledTabPanel.value + 1;
			setNavScrollPosition();
		}
	};

	onMounted(() => {
		setPanelHeight(0);
		setNavVisibility();
		setNavScrollPosition();
	});

	watch(screenSize, () => {
		if (screenSize.value && centerTabs.value){
			setNavVisibility();
			setNavScrollPosition();
		}
	});
	watch(() => props.current, (v: number | undefined) => {
		if (typeof v == 'number'){
			setPanelHeight(v, true);
			current.value = v;
			scrolledTabPanel.value = v;
			
			setTimeout(() => {
				setNavVisibility();
				setNavScrollPosition();
			},1);
		}
	});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "tabPanelTabs",
    ref: tabPanelTabs,
    class: _normalizeClass([
			'tb-tab-block',
			{'tb-fade-overlay': !!_unref(scrollOnMobile) && isTabPanelListScrollable.value},
			{'tb-no-scroll': !_unref(scrollOnMobile)}
		])
  }, [
    (_unref(useMobileNav) && isTabPanelListScrollable.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "tb-tab-block-nav",
          "aria-label": "Scroll tabs menu left",
          onClick: _withModifiers(handleLeftClick, ["prevent"]),
          onKeydown: _withKeys(_withModifiers(handleLeftClick, ["prevent"]), ["left"])
        }, null, 40, _hoisted_1))
      : _createCommentVNode("", true),
    (_unref(useMobileNav) && isTabPanelListScrollable.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          class: "tb-tab-block-nav",
          "aria-label": "Scroll tabs menu right",
          onClick: _withModifiers(handleRightClick, ["prevent"]),
          onKeydown: _withKeys(_withModifiers(handleRightClick, ["prevent"]), ["right"])
        }, null, 40, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("ul", {
      role: "tabpanel",
      ref_key: "tabPanelList",
      ref: tabPanelList,
      class: _normalizeClass([
				'tb-tab-block-tabs',
				{'tb-has-tab-block-nav': _unref(useMobileNav)},
				{'tb-center': _unref(centerTabs)},
				{'tb-can-scroll': isTabPanelListScrollable.value}
			])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: i-1,
          class: _normalizeClass(!_ctx.$slots[`tab-${i-1}`] ? 'tb-blank' : ''),
          role: "presentation"
        }, [
          _createElementVNode("button", {
            type: "button",
            role: "tab",
            "aria-pressed": i-1 == current.value,
            "aria-controls": `tb-tab-block-panel-${i-1}-${__props.uid}`,
            onClick: ($event: any) => (handleTabClick(i-1))
          }, [
            _renderSlot(_ctx.$slots, `tab-${i-1}`)
          ], 8, _hoisted_3)
        ], 2))
      }), 128))
    ], 2),
    _createElementVNode("div", {
      class: "tb-tab-block-panel-holder",
      style: _normalizeStyle(!_unref(disableAnimation) ? _unref(panelHolderStyle) : '')
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (i) => {
        return (_openBlock(), _createElementBlock("div", {
          ref_for: true,
          ref: el => tabPanels.value.push(el),
          key: i-1,
          id: `tb-tab-block-panel-${i-1}-${__props.uid}`,
          "aria-hidden": current.value != i-1,
          class: "tb-tab-block-panel"
        }, [
          _renderSlot(_ctx.$slots, `tabpanel-${i-1}`)
        ], 8, _hoisted_4))
      }), 128))
    ], 4)
  ], 2))
}
}

})